import React, { ChangeEvent } from 'react'

import TextInput from 'components/TextInput'

import FormSection from 'pages/shared/FormSection'

import { scrubText } from 'helpers/inputCleaners'

type ActionButtonFieldsErrors = {
  actionButtonCaption?: string
  actionButtonLink?: string
}

type ActionButtonFieldsProps = {
  onChangeCallback: (update: { actionButtonCaption?: string; actionButtonLink?: string }) => void
  caption?: string
  link?: string
  errors?: ActionButtonFieldsErrors
}

const ActionButtonFields = ({ caption = '', link = '', onChangeCallback, errors = {} }: ActionButtonFieldsProps) => {
  const handleLinkChange = (event: ChangeEvent<HTMLInputElement>) => {
    let url = scrubText(event.target.value, true)
    if (url && !url.toLowerCase().startsWith('http')) {
      url = `https://${url}`
    }
    onChangeCallback({ actionButtonLink: url })
  }

  return (
    <FormSection title="Action Button">
      <TextInput
        label="Caption"
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChangeCallback({ actionButtonCaption: scrubText(event.target.value, true) })}
        value={caption || ''}
        errorMessage={errors.actionButtonCaption}
      />

      <TextInput
        label="Link"
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChangeCallback({ actionButtonLink: scrubText(event.target.value, true) })}
        onBlur={handleLinkChange}
        value={link || ''}
        type="url"
      />
    </FormSection>
  )
}

export default ActionButtonFields
